import { Box, Divider, Tooltip, Typography, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import DispatchEventStatus from '@product-framework/components/DispatchEventStatus';
import TextButton from '@product-framework/components/TextButton';
import { IconLibrary } from '@product-framework/index';
import formatDateTime from '@product-framework/utils/formatDateTime';
import ReadMoreText from '@ui-framework/components/UI/ReadMoreText';
import MultiValueDisplay from '@ui-framework/helpers/MultiValueDisplay';
import fetchAcceptedWithConditions from '../../lib/fetchAcceptedWithConditions';

function ServiceProviderName({ sp, disabled = false, onClickHandler }) {
  const theme = useTheme();

  return (
    <Box>
      {!disabled ? (
        <TextButton
          onClick={e => {
            onClickHandler(e);
          }}
          sx={{
            textAlign: 'left',
          }}
          variant="text">
          {sp.name}
        </TextButton>
      ) : (
        <Typography variant="body" color={theme.palette.text.disabled}>
          {sp.name}
        </Typography>
      )}
      <Box>
        {sp?.dispatchEvent?.status === 'ACCEPTED_WITH_CONDITIONS' ? (
          <Tooltip
            title={
              <Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    mb: 1,
                  }}>
                  <Typography sx={{ textAlign: 'center' }}>
                    <FormattedMessage
                      id="CONDITIONS_FOR_ACCEPTANCE"
                      defaultMessage="Conditions for Acceptance"
                    />
                  </Typography>
                  <Divider
                    sx={{
                      width: '100%',
                      mb: 1,
                      borderColor: '#ffffff',
                    }}
                  />
                </Box>
                {fetchAcceptedWithConditions({
                  ReadMoreText,
                  MultiValueDisplay,
                  formatDateTime,
                  sp,
                })}
              </Box>
            }
            arrow>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <DispatchEventStatus
                showAsText
                small
                value={sp?.dispatchEvent?.status}
              />
              <IconLibrary.Info
                sx={{ fontSize: '16px', marginLeft: 0.4, cursor: 'pointer' }}
                color="info"
              />
            </Box>
          </Tooltip>
        ) : (
          <DispatchEventStatus
            showAsText
            small
            value={sp?.dispatchEvent?.status}
          />
        )}
      </Box>
    </Box>
  );
}

export default ServiceProviderName;
